
export const reorderVectorTileLayers = (map, layerIds, beforeLayerId) => {
  try {
    // Move each layer to appear BEFORE the specified layer
    layerIds.forEach((layerId) => {
      if (map.getLayer(layerId) && map.getLayer(beforeLayerId)) {
        map.moveLayer(layerId, beforeLayerId);
      }
    });
  } catch (error) {
    console.error('Error reordering layers:', error);
  }
};
export const getVectorValueAtPoint = async (config, lng, lat) => {
  try {
    // For vector tiles, we might need to query feature properties
    // This depends on your backend API structure
    const url = `${process.env.REACT_APP_MAPPER_VEGETATION_BASEURL_V1}/${config.id}/features?lon=${lng}&lat=${lat}`;
    
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    
    const data = await response.json();
    return data?.features || [];
  } catch (err) {
    console.error(`Error fetching ${config.name} features:`, err);
    return null;
  }
};
